import WorkspaceLogo from './WorkspaceLogo'
import WorkspaceLogoIcon from './WorkspaceLogoIcon'
import { Wrapper } from './WorkspaceLogo.styles'

export default Object.assign(WorkspaceLogo, {
  Icon: WorkspaceLogoIcon,
  Wrapper,
})
